import { Flex } from "@fluentui/react-northstar";
import React from "react";

import { ResponseUsageMeter } from "../../../../_shared/components/MeterBars/ResponseUsageMeter";

export const EditingWarningAlert: React.FC<{ isLimitedEdit: boolean; responsesCount: number }> = ({
  isLimitedEdit,
  responsesCount,
}) => (
  <Flex vAlign="center">
    <Flex.Item grow>
      <div className="polly-authoring-page__back-button">
        {isLimitedEdit && (
          <span>
            <span style={{ color: "#A16114" }}>
              <b>ⓘ Limited Editing</b>
              {responsesCount > 0 && (
                <>
                  <b>:</b>
                  {" polly has "}
                  <b>{responsesCount === 1 ? `one response` : `${responsesCount} responses`}</b>
                </>
              )}
            </span>{" "}
            <a
              href="https://www.polly.ai/help/microsoft-teams/editing-a-published-polly"
              target="_blank"
              rel="noopener noreferrer"
              className="brand-link"
            >
              Learn more
            </a>
          </span>
        )}
      </div>
    </Flex.Item>
    <Flex.Item push>
      <ResponseUsageMeter />
    </Flex.Item>
  </Flex>
);
